import apiClient from './apiClient.js';

// Resolved SEO for a public static page, by path (e.g. '/about').
export const getPageMeta = (path) =>
  apiClient.get('/seo/meta', { params: { path } });

export const getSeoMeta = (resourceType, resourceId) =>
  apiClient.get(`/seo/${resourceType}/${resourceId}`);

export const upsertSeoMeta = (resourceType, resourceId, data) =>
  apiClient.put(`/seo/${resourceType}/${resourceId}`, data);
